var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseIcon2({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62132 7.5L2.12132 0L0 2.12132L7.5 9.62132L0.12132 17L2.24264 19.1213L9.62132 11.7426L16.9706 19.0919L19.0919 16.9706L11.7426 9.62132L19.2132 2.15076L17.0919 0.0294356L9.62132 7.5Z",
    fill: "white"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjYyMTMyIDcuNUwyLjEyMTMyIDBMMCAyLjEyMTMyTDcuNSA5LjYyMTMyTDAuMTIxMzIgMTdMMi4yNDI2NCAxOS4xMjEzTDkuNjIxMzIgMTEuNzQyNkwxNi45NzA2IDE5LjA5MTlMMTkuMDkxOSAxNi45NzA2TDExLjc0MjYgOS42MjEzMkwxOS4yMTMyIDIuMTUwNzZMMTcuMDkxOSAwLjAyOTQzNTZMOS42MjEzMiA3LjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgCloseIcon2 as ReactComponent };